import './ribbongrid.css';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SpecialRibbon } from './../RibbonNew';
import Scrollable from './../Scrollable';
import ActivesSingleton from '../Header/ActivesSingleton';
import RibbonsUtil from '../../utils/RibbonsUtil';
import Utils, {getNodeHeaderImage} from '../../utils/Utils';
import Ribbon from './../RibbonNew';
import { MUSIC_RIBBON_TYPE, NODE_RIBBONS, REMOVE_RIBBON, RIBBON_NAME } from './constants';
import Device from './../../devices/device';
import {
  VOID,
  FAVORITED_API,
  SEEN_API,
  RECORDINGS_API,
  LIVECHANNEL_API,
  RECORDINGS,
  MUNDIALSOCCERMATCHER,
  COMPLETED,
  SEEN_API_V1,
  FAVORITED_API_V1,
  LIVECHANNEL_API_V1,
  PLANSELECTOR,
  EXIT,
  PLANSOFFERV2, ROOT_ID_PLAN_SELECTOR_CARD, INITIAL_ID_PLAN_SELECTOR_BUTTON_BLUE
} from '../RibbonNew/constants';
import RecordingProgressBar from './../RecordingProgressBar';
import {
  DELETE_CARD,
  UPDATE_CARD,
  UpdateCardFromRibbonUserObserver,
} from '../PersistentMiniEpg/MiniObserver';
import {
    showModal,
    MODAL_DELETE_TV_CHANNEL,
    HIDE_MODAL,
    MODAL_DELETE_LAST_SEEN,
    MODAL_DELETE_RECORDINGS,
    MODAL_DELETE_FAVORITE,
    MODAL_RECORD_SERIES_CONTENT,
    AAF_MODAL_ERROR,
    MODAL_PIN
} from '../../actions/modal';
import store from '../../store';
import * as api from '../../requests/loader';
import { setLastTouchLiveChannel, setLastTouchFavorited } from '../../reducers/user';
import LoadFav from '../../AAF/LoaderExp/LoadFav';
import { NpvrUtil } from '../../AAF/Npvr/NpvrUtil';
import NpvrUploader from '../../AAF/Npvr/NpvrUploader';
import SimpleGetRequestTask from '../../requests/tasks/SimpleGetRequestTask';
import RequestManager from '../../requests/RequestManager';
import DeviceStorage from '../DeviceStorage/DeviceStorage';
import { NPVR_RECORDABLE_EVENT_STATUS, FALSE, RECORDING, CONTENIDO } from '../../AAF/Npvr/Constans';
import LayersControl from '../../utils/LayersControl';
import ChannelSingleton from '../Epg/ChannelsSingleton';
import GeneralRibbonUtils from '../RibbonNew/GeneralRibbonUtils';
import { sendGAEvent } from '../../utils/analytics';
import channelStreamUtil from '../../utils/ChannelStreamUtil';
import Asset from '../../requests/apa/Asset';
import { getTransactionalLabels } from '../../payments/utils/Utils';
import * as PlanSelectorUtils from '../../payments/PlanSelector/PlanSelectorUtils';
import { setUserPlans } from '../../../src/actions/plans';
import { GA4 } from '../../utils/trackers/GA4';
import { AdsUtils } from '../../AAF/Ads/Utils';
import {getIdsRibbonsUpAndDown, getParamsRibbons} from "./utis";
import {isActiveFocusDynamic, removeDynamicFocus} from "../Focus/utils";
import { getIsMundial2026 } from '../../containers/Mundial2026/utils';
import { channelIsBlocked } from './utis';

class RibbonGrid extends Component {
  constructor(props) {
    super(props);
    this.focused = null;
    this.DOWN = 'DOWN';
    this.UP = 'UP';
    this.moveToSelector = null;
    this.title = null;
    this.btnplanselector = `${INITIAL_ID_PLAN_SELECTOR_BUTTON_BLUE}${ROOT_ID_PLAN_SELECTOR_CARD}`;

    this.state = {
      topPosition: 0,
      ribbonsPrev: this.props.ribbonsPrev != undefined ? this.props.ribbonsPrev : [],
      ribbonsRest: [],
      ribbonsCategories: this.props.ribbonsCategories,
      ribbonsTypeMenu: this.props.ribbonsTypeMenu,
    };
    this.ribbonsRecordings = null;
    if (this.props.ribbonsTypeMenu == 'music') {
      this.onFocusCardHandler = this.onFocusCardHandler.bind(this);
    }

    if (this.props.ribbonsTypeMenu == 'home') {
      this.handleFocus = this.handleFocus.bind(this);
      this.keyDownHandler = this.keyDownHandler.bind(this);
      this.handleDeleteFromRibbonLiveChannel =
        this.handleDeleteFromRibbonLiveChannel.bind(this);
      this.handleDeleteFromRibbonFavorite = this.handleDeleteFromRibbonFavorite.bind(this);
      this.handleDeleteFromRibbonRecordings =
        this.handleDeleteFromRibbonRecordings.bind(this);
    }
    this.getApiType = this.getApiType.bind(this);
    this.currentRibbonIdFocused = null;
    this.currentRibbonTypeFocused = null;
    this.currentCardFocused = null;
    this.keys = Device.getDevice().getKeys();
    Utils.setMaxRibbonMarginTop(0);
    this.hasRecordings = false;
    this.isModalRecordSeriesContent = Utils.modalType() === MODAL_RECORD_SERIES_CONTENT;
    this.handleOnClickPlanSelector = this.handleOnClickPlanSelector.bind(this);
    this.ga4 = new GA4();

  }

  componentDidMount() {
    this.addEventListeners();
    this.hasRecordings = this.props.code.includes('contenido');
    
    const region = DeviceStorage.getItem('region');
    this.headerImageUrl = getNodeHeaderImage(this.props.code, region);
    
    if (this.props.ribbonsTypeMenu == 'home') {
      setTimeout(() => {
        const modal = document.getElementsByClassName('modal-overlay');
        if (modal.length == 0) {
          if (document.getElementsByClassName('ribbon-highlight').length == 0) {
            window.SpatialNavigation.focus('.scroller-container .focusable.selected');
          } else {
            window.SpatialNavigation.focus('.scroller-container .focusable');
          }
        }
      }, 300);
    }
    window.addEventListener("scroll", this.handleScroll);
  }

  cardOnFocus(event) {
    const { target: { firstChild, classList } = {} } = event || {};
    const { className = false } = firstChild || {};

    if (!classList.contains('link-zoom') && className && className.indexOf('card') !== -1) {
      setTimeout(() => {
        event.target.classList.add('link-zoom-week');
      }, 200);
    }
  }

  cardOnBlur(event) {
    const { target: { firstChild, classList } = {} } = event || {};
    const { className = false } = firstChild || {};

    if (!classList.contains('link-zoom') && className && className.indexOf('card') !== -1) {
      setTimeout(() => {
        event.target.classList.remove('link-zoom-week');
        //console.log('cardOnBlur:::');
      }, 200);
    }

  }

  addEventListeners() {
    if (this.props.ribbonsTypeMenu == 'home') {
      this.removeEventListeners();
      document.addEventListener('keydown', this.keyDownHandler);
      document.addEventListener('sn:focused', this.cardOnFocus);
      document.addEventListener('sn:unfocused', this.cardOnBlur);
    }
  }

  removeEventListeners() {
    let element = document;
    if (this.isModalRecordSeriesContent) {
      const scrollerContainer = document.querySelector('.scrollabe-container-modal-series-content');
      if (scrollerContainer) element = scrollerContainer;
    }
    if (this.props.ribbonsTypeMenu == 'home') {
      element.removeEventListener('keydown', this.keyDownHandler);
      element.removeEventListener('sn:focused', this.cardOnFocus);
      element.removeEventListener('sn:unfocused', this.cardOnBlur);
    }
  }

  componentWillUnmount() {
    this.removeEventListeners();
    window.removeEventListener("scroll", this.handleScroll);
  }

  getApiType(uriApi) {
    let response = '';
    if (!uriApi) {
      return response;
    }
    if (uriApi.includes(FAVORITED_API)) {
      response = FAVORITED_API;
    }
    if (uriApi.includes(FAVORITED_API_V1)) {
      response = FAVORITED_API_V1;
    }
    if (uriApi.includes(SEEN_API)) {
      response = SEEN_API;
    }
    if (uriApi.includes(SEEN_API_V1)) {
      response = SEEN_API_V1;
    }
    if (uriApi.includes(RECORDINGS_API)) {
      response = RECORDINGS_API;
    }
    if (uriApi.includes(LIVECHANNEL_API)) {
      response = LIVECHANNEL_API;
    }
    if (uriApi.includes(LIVECHANNEL_API_V1)) {
      response = LIVECHANNEL_API_V1;
    }
    return response;
  }

    async keyDownHandler(e) {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        if (LayersControl.isPlayerVisible()) {
            return;
        }
        console.log(
            '[KDOWN3] RibbonGrid> currentKey|ribbonId|data: ',
            currentKey,
            this.currentRibbonIdFocused,
            this.currentCardFocused,
            this.currentRibbonTypeFocused
        );

        switch (currentKey) {
            case 'RED':
                e.preventDefault();
                e.stopPropagation();
                const navbar = store.getState().navbar;
                if (navbar && navbar.nodes && navbar.nodes.length > 0) {
                    const node = navbar.nodes.find((node) => node.code === this.props.code);
                    if (node && node.text && node.text !== '' && this.currentCardFocused && this.currentCardFocused.title) {
                        sendGAEvent({
                            hitType: 'event',
                            eventCategory: NODE_RIBBONS.replace('{{NODE_NAME}}', node.text),
                            eventAction: REMOVE_RIBBON.replace(
                                '{{RIBBON_NAME}}',
                                this.props.ribbonsPrev.find(
                                    (ribbon) => ribbon.id === this.currentRibbonIdFocused
                                ).title
                            ),
                            eventLabel: this.currentCardFocused.title,
                        });
                    }
                }
                const apiType = this.getApiType(this.currentRibbonApi);
                switch (apiType) {
                    case LIVECHANNEL_API:
                    case LIVECHANNEL_API_V1:
                        this.handleDeleteFromRibbonLiveChannel(this.currentCardFocused, apiType);
                        break;
                    case RECORDINGS_API:
                        const { group_id: groupIdChannelRecording } = this.currentCardFocused || {};
                        let isChannelRecordingBlocked = false;
                        try {
                            isChannelRecordingBlocked = await channelIsBlocked(groupIdChannelRecording);
                        } catch (err) {
                            console.error('Error verificando canal bloqueado (recordings)', err);
                        }

                        const modalPinOrDeleteRecordings = isChannelRecordingBlocked ? MODAL_PIN : MODAL_DELETE_RECORDINGS;
                        this.handleDeleteFromRibbonRecordings(this.currentCardFocused, modalPinOrDeleteRecordings, apiType);
                        break;
                    case SEEN_API:
                    case SEEN_API_V1:
                        this.handleDeleteFromRibbonLastSeen(this.currentCardFocused, apiType);
                        break;
                    case FAVORITED_API:
                    case FAVORITED_API_V1:
                        const { group_id: groupIdChannelFavorite, type } = this.currentCardFocused || {};
                        const isLive = type === 'live';
                        let isChannelFavoriteBlocked = null;
                        if (isLive) {
                            try {
                                isChannelFavoriteBlocked = await channelIsBlocked(groupIdChannelFavorite);
                            } catch (err) {
                                console.error('Error verificando canal bloqueado (favorite)', err);
                            }
                        }

                        const modalPinOrDeleteFavorite = isChannelFavoriteBlocked ? MODAL_PIN : MODAL_DELETE_FAVORITE;
                        this.handleDeleteFromRibbonFavorite(this.currentCardFocused, modalPinOrDeleteFavorite, apiType);
                        break;
                    default:
                        break;
                }
                break;
            case 'DOWN':
                // console.log('DOWN RibbonGridNew:::::', this.currentCardFocused, this.currentRibbonIdFocused);
                if (this.currentRibbonTypeFocused && this.currentRibbonTypeFocused.indexOf(PLANSELECTOR) !== -1) {
                    console.log('DOWN Plan-Selector:::::', this.currentCardFocused);
                    const moreInfoElement = document.querySelector('.aaf_ribbon-plan-selector-item-more-info');

          //* Verifica si el elemento existe
          if (moreInfoElement) {
            const anchorElement = moreInfoElement.querySelector('.aaf_ribbon-plan-selector-item-more-info-tab-active');
            const elementDown = document.querySelector('.link-planselector');

            anchorElement.classList.add('focusable', 'link-zoom-week');
            elementDown.classList.add('nonfocusable');
          }
        }
        break;
      case 'LEFT':
      case 'RIGHT':
        if (this.currentRibbonTypeFocused && this.currentRibbonTypeFocused.indexOf(PLANSELECTOR) !== -1) {
          //* Verifica si el elemento existe
          const moreInfoElement = e.target;

          if(Utils.modalType() !== EXIT){
            /**
             * Verifica si el ID del elemento `moreInfoElement` incluye el valor de `btnplanselector`.
             * Si coincide, previene el comportamiento predeterminado del evento y detiene su propagación.
             *
             * @param {Event} e - El evento que se está manejando.
             * @param {HTMLElement} moreInfoElement - El elemento HTML que se está evaluando.
             * @property {string} id - El ID del elemento que se compara con `btnplanselector`.
             */
            if (moreInfoElement.id.includes(this.btnplanselector)) {
              e.preventDefault();
              e.stopPropagation();
            }
          }
        }
        break;
      case 'UP':
        // console.log('UP RibbonGridNew:::::', this.currentCardFocused, this.currentRibbonIdFocused);
        if (this.currentRibbonTypeFocused && this.currentRibbonTypeFocused.indexOf(PLANSELECTOR) !== -1) {
          const moreInfoElement = document.querySelector('.aaf_ribbon-plan-selector-item-more-info-tab-active');

          if (this.currentCardFocused.offerid === moreInfoElement.id) {
            //* Si existe, remueve el focusable para hacerlo no enfocable
            const elementUp = document.querySelector('.link-planselector');
            if(Utils.modalType() !== EXIT){
              if (moreInfoElement.classList.contains('link-zoom-week')) {
                //* El elemento tiene la clase 'focusable'
                moreInfoElement.classList.remove('focusable', 'link-zoom-week');

                if (elementUp.classList.contains('nonfocusable')) {
                  elementUp.classList.remove('nonfocusable');
                  this.cardOnFocus({ target: elementUp });

                  Utils.setInitialFocusChangeTime(`#${moreInfoElement.id}`, 0);
                }
              }
            }
          }
        }
        break;
      case 'BLUE':
        e.preventDefault();
        e.stopPropagation();
        if (this.currentRibbonTypeFocused && this.currentRibbonTypeFocused.indexOf(PLANSELECTOR) !== -1) {
          console.log('OK Plan-Selector y boton azul:::::', this.currentCardFocused);
          const elementDown = document.querySelector('.link-planselector');
          const moreInfoElement = e.target;
          const reviewClassZoomWeek = !isActiveFocusDynamic() ? moreInfoElement.classList.contains('link-zoom-week') : true

          if (this.currentCardFocused.offerid === elementDown.id) {

            if (reviewClassZoomWeek) {
              //* El elemento tiene la clase 'focusable'
              this.handleOnClickPlanSelector(this.currentCardFocused);
              elementDown.classList.remove('focusable', 'link-zoom-week');
            }
          }

          if (moreInfoElement.id.includes(ROOT_ID_PLAN_SELECTOR_CARD)) {
            if (reviewClassZoomWeek) {
              //* El elemento tiene la clase 'focusable'
              this.handleOnClickPlanSelector(this.currentCardFocused);
              moreInfoElement.classList.remove('focusable', 'link-zoom-week');
            }
          }
        }
        break;
      case 'OK':
        e.preventDefault();
        e.stopPropagation();

        const headerbrandElement = document.querySelector('.HeadBrandContainer');
        if (headerbrandElement) headerbrandElement.style.display = 'none';

        if (this.currentRibbonTypeFocused && this.currentRibbonTypeFocused.indexOf(PLANSELECTOR) !== -1) {
          const moreInfoElement = e.target;
          if(Utils.modalType() !== EXIT){
            if (moreInfoElement.id.includes(ROOT_ID_PLAN_SELECTOR_CARD)) {
              if (moreInfoElement.id.includes(this.btnplanselector)) {
                //* El elemento tiene la clase 'focusable'
                this.handleOnClickPlanSelector(this.currentCardFocused);
                moreInfoElement.classList.remove('focusable', 'link-zoom-week');
              }
            }
          }
        }
        break;
      default:
        break;
    }
  }

  isFromModalListSerie = (data) => {
    return data && data.from && data.from === 'ModalRecordSeriesContent';
  };

  async deleteRecording(data) {
    const groupId = data.group_id;
    const eventId = data.event_id;
    const eventAlfId = data.event_alf_id;
    const actions = data.actions || {};
    const ribbonRecordings = this.props.ribbonsUser.filter(
      (ribbon) => ribbon.id === this.currentRibbonIdFocused
    );

    const getData = () => {
      this.moveToSelector = null;
      if (ribbonRecordings[0].items.length > 1) {
        this.moveToSelector = 'link-recordings';
      }
      UpdateCardFromRibbonUserObserver.fire({
        action: DELETE_CARD,
        cardGroupId: eventId,
        ribbonIds: [this.currentRibbonIdFocused],
        card: data,
      });
    };

    getData.bind(this);

    if (NpvrUtil.recordingIconEnable().enable) {
      if (NpvrUploader.isEventSerie(data)) {
        await NpvrUploader.updateStatusFromListSerie(
          data.ext_series_id,
          groupId,
          NPVR_RECORDABLE_EVENT_STATUS,
          true,
          data.season_id
        );
        NpvrUploader.deleteByUrl(actions.delete, groupId).then(() => {
          getData();
        });
      } else {
        NpvrUploader.deleteByUrl(actions.delete, groupId, eventId, eventAlfId).then(async () => {
          if (this.isFromModalListSerie(data)) {
            if (data && data.listSerieParams) {
              const result = await new GeneralRibbonUtils.handleRecordingSeries(
                data.listSerieParams
              );
              if (!result) {
                // SE CIERRA MODAL Y SE ELIMINA LA GRABACION DEL DOM
                store.dispatch(
                  showModal({
                    modalType: HIDE_MODAL,
                    modalProps: {},
                  })
                );
                if (
                  data.listSerieParams.data &&
                  data.listSerieParams.data.ext_series_id
                ) {
                  UpdateCardFromRibbonUserObserver.fire({
                    action: DELETE_CARD,
                    cardGroupId: data.listSerieParams.data.ext_series_id,
                    ribbonIds: [this.currentRibbonIdFocused],
                    card: data.listSerieParams.data,
                  });
                }
              } else {
                if (
                  data.listSerieParams.data &&
                  data.listSerieParams.data.ext_series_id
                ) {
                  UpdateCardFromRibbonUserObserver.fire({
                    action: UPDATE_CARD,
                    cardGroupId: data.listSerieParams.data.ext_series_id,
                    ribbonIds: [this.currentRibbonIdFocused],
                    card: { numEpisodesNew: result },
                  });
                }
              }
            }
            return;
          } else {
            getData();
          }
        });
      }
    } else {
      const deleteRecordingTask = new SimpleGetRequestTask(actions.delete, null);
      const result = await RequestManager.addRequest(deleteRecordingTask);
      getData();
      if (!result.response.success) {
      } else {
        const saved = DeviceStorage.getItem('recordings');
        const parsed = Utils.isJson(saved) ? JSON.parse(saved) : {};
        if (data && data.eventid_programme_id && parsed[data.eventid_programme_id]) {
          delete parsed[data.eventid_programme_id];
          DeviceStorage.setItem('recordings', JSON.stringify(parsed));
        }
      }
    }
  }

    async handleDeleteFromRibbonRecordings(data, whichModalToShow) {
        if (data && !data.cover) {
            const gidData = channelStreamUtil.get(data.group_id);
            if(gidData && gidData.cover) {
                data.cover = gidData.cover;
            } else {
                data.cover = Asset.get('asset_placeholder_landscape','/images/placeholder_landscape.png');
            }
        } else {
            data.cover = data.cover.replace('size=168x96', 'size=290x163');
        }
        const closeModal = () => {
            store.dispatch(
                showModal({
                    modalType: HIDE_MODAL,
                    modalProps: {},
                })
            );
        };

        // MODAL_PIN usa successCallBack y MODAL_DELETE_RECORDINGS usa onSuccess.
        const callbackName = whichModalToShow === 'PIN' ? 'successCallBack' : 'onSuccess';
        const modal = {
            modalType: whichModalToShow,
            modalProps: {
                data,
                [callbackName]: () => {
                    this.deleteRecording(data)
                        .then(() => {
                            if (this.isFromModalListSerie(data)) {
                                return;
                            }
                            closeModal();
                        })
                        .catch((err) => {
                            closeModal();
                        });
                },
                onCancel: () => {
                    closeModal();
                },
            },
        };
        store.dispatch(showModal(modal));
    }

  handleDeleteFromRibbonLastSeen(data) {
    const ribbonLastSeen = this.props.ribbonsUser.filter(
      (ribbon) => ribbon.id === this.currentRibbonIdFocused
    );
    if (ribbonLastSeen && ribbonLastSeen[0]) {
      const closeModal = () => {
        store.dispatch(
          showModal({
            modalType: HIDE_MODAL,
            modalProps: {},
          })
        );
      };

      const modal = {
        modalType: MODAL_DELETE_LAST_SEEN,
        modalProps: {
          data,
          onSuccess: () => {
            api.removeLastSeen(data.group_id)
              .then(() => {
                UpdateCardFromRibbonUserObserver.fire({
                  action: DELETE_CARD,
                  cardGroupId: data.group_id,
                  ribbonIds: [this.currentRibbonIdFocused],
                });
                closeModal();
              })
              .catch((err) => {
                closeModal();
              });
          },
          onCancel: () => {
            closeModal();
          },
        },
      };
      store.dispatch(showModal(modal));
    }
  }

    handleDeleteFromRibbonFavorite(data, whichModalToShow) {
        const ribbonsUser = this.props.ribbonsUser;
        const ribbonFavorite = ribbonsUser.filter(
            (ribbon) => ribbon.id === this.currentRibbonIdFocused
        );

    const getAllRibbonsFavorited = () => {
      const arrayWithRibbonsFavorited = ribbonsUser.map((ribbonUser) => {
        const urlRibbonUser = ribbonUser.url;
        const existRibbonFavorited = urlRibbonUser.includes('favorited');
        if (existRibbonFavorited) {
          return ribbonUser.id;
        }
      }).filter((value) => value !== undefined);
      return arrayWithRibbonsFavorited;
    }
    const arrayWithIdsRibbonsFavorited = getAllRibbonsFavorited();

    if (ribbonFavorite && ribbonFavorite[0]) {
      const closeModal = () => {
        store.dispatch(
          showModal({
            modalType: HIDE_MODAL,
            modalProps: {},
          })
        );
      };

            // MODAL_PIN usa successCallBack y MODAL_DELETE_FAVORITE usa onSuccess.
            const callbackName = whichModalToShow === 'PIN' ? 'successCallBack' : 'onSuccess';
            const modal = {
                modalType: whichModalToShow,
                modalProps: {
                    data,
                    [callbackName]: () => {
                        const live = data.type === 'live';
                        api.deleteFavorite(data.group_id, live)
                            .then((response) => {
                                const responseData = response.data;
                                if (responseData && responseData.lasttouch && responseData.lasttouch.favorited) {
                                    store.dispatch(
                                        setLastTouchFavorited(responseData.lasttouch.favorited)
                                    );
                                }
                                UpdateCardFromRibbonUserObserver.fire({
                                    action: DELETE_CARD,
                                    cardGroupId: data.group_id,
                                    ribbonIds: arrayWithIdsRibbonsFavorited,
                                });
                                LoadFav.deleteFav(data.group_id);
                                closeModal();
                            })
                            .catch((err) => {
                                closeModal();
                            });
                    },
                    onCancel: () => {
                        closeModal();
                    },
                },
            };
            store.dispatch(showModal(modal));
        }
    }

  handleDeleteFromRibbonLiveChannel(data) {
    const ribbonLiveChannel = this.props.ribbonsUser.filter(
      (ribbon) => ribbon.id === this.currentRibbonIdFocused
    );
    if (ribbonLiveChannel && ribbonLiveChannel[0]) {
      const closeModal = () => {
        store.dispatch(
          showModal({
            modalType: HIDE_MODAL,
            modalProps: {},
          })
        );
      };

      const modal = {
        modalType: MODAL_DELETE_TV_CHANNEL,
        modalProps: {
          data,
          onSuccess: () => {
            // Llamar api

            api.removeLiveChannel(data.group_id)
              .then((resp) => {
                const { lasttouch: { livechannel = null } = {} } = resp;
                if (livechannel) {
                  store.dispatch(setLastTouchLiveChannel(livechannel));
                  this.moveToSelector = null;
                  if (ribbonLiveChannel[0].items.length > 1) {
                    this.moveToSelector = 'link-livechannel';
                  }
                  UpdateCardFromRibbonUserObserver.fire({
                    action: DELETE_CARD,
                    cardGroupId: data.group_id,
                    ribbonIds: [this.currentRibbonIdFocused],
                  });
                }
                // Llamar al last touch?
                closeModal();
              })
              .catch((err) => {
                closeModal();
              });
          },
          onCancel: () => {
            closeModal();
          },
        },
      };
      store.dispatch(showModal(modal));
    }
  }

  async handleOnClickPlanSelector(dataFocused) {

    console.log(':::Clic boton que incluye plan selector');
    const { history } = this.props;
    const urlFlowType = history.location.pathname;
    AdsUtils.isAdsEnable() && this.ga4.sendMetricsPlanSelectorRibbonHomePremium(dataFocused, urlFlowType);
    let providerLogo = '';

    if(dataFocused.type === PLANSELECTOR){
      providerLogo = Asset.get(`transactional_${dataFocused.family}_logo`);
      this.title = this.props.ribbonsPrev.find((ribbon) => (ribbon.type === PLANSELECTOR) || (ribbon.type === PLANSOFFERV2)).items;
    }else{
      this.title = this.props.ribbonsUser.find((ribbon) => (ribbon.type === PLANSELECTOR) || (ribbon.type === PLANSOFFERV2)).items;
      providerLogo = dataFocused.logo.logo;

      const userPlansRedux =  store.getState().plans && store.getState().plans.userPlans && store.getState().plans.userPlans.button;

      if(!userPlansRedux){
        await this.getfamilyPBI(dataFocused.offerid);
      }else{
        await this.getfamilyPBIRedux(userPlansRedux, dataFocused.offerid);
      }
    }

    const labels = getTransactionalLabels();
    const details = dataFocused.type === PLANSELECTOR ? PlanSelectorUtils.parseDetailPlan(this.title, labels) : PlanSelectorUtils.parseDetailPlanOffer(this.title, labels);
    const detail = details.find((detail) => detail.id === dataFocused.offerid);
    const activePlan = {
      "providerLogo": providerLogo,
      "pbi": {
        ...dataFocused
      },
      "buttons": [...detail.buttons]
    };

    history.push('/detailSelector', { activePlan, metricsHistoryAddon: true, urlFlowType, forceReset: false});
  }

  async getfamilyPBI(offerid){
    await api.PurchaseButtonInfov585({object_type: "A"})
      .then((resp) => {
        const { listButtons:{button = {}} } = resp;
        const offerData = button && button.find((offer) => (offer.offerid === offerid));
        const indicePS = this.title && this.title.findIndex(obj => obj.offerid === offerid);
        this.title[indicePS].purchasable = offerData.purchasable;
        this.title[indicePS].family = offerData.family;
            this.title[indicePS].bonus = offerData.bonus;
            this.title[indicePS].producttype = offerData.producttype;
            this.title[indicePS].periodicity = offerData.periodicity;
            this.title[indicePS].banner = offerData.banner;
            this.title[indicePS].oneoffertype = offerData.oneoffertype;

        store.dispatch(setUserPlans({
          button
        }));
        return offerData;
      })
      .catch((err) => {
        this.showError(err);
      });
  }

  getfamilyPBIRedux = async (button, offerid) => {
    const offerData = button && button.find((offer) => (offer.offerid === offerid));
    const indicePS = this.title && this.title.findIndex(obj => obj.offerid === offerid);
    this.title[indicePS].purchasable = offerData.purchasable;
    this.title[indicePS].family = offerData.family;
    this.title[indicePS].bonus = offerData.bonus;
    this.title[indicePS].producttype = offerData.producttype;
    this.title[indicePS].periodicity = offerData.periodicity;
        this.title[indicePS].banner = offerData.banner;
        this.title[indicePS].oneoffertype = offerData.oneoffertype;
  }

  showError(errors, callback) {
    if (errors) {
      const modal = {
        modalType: AAF_MODAL_ERROR,
        modalProps: {
          callback,
          content: errors
        }
      };
      store.dispatch(showModal(modal));
    }
    this.setOpacity(false);
  }

  setOpacity(value) {
    const buttons = document.querySelectorAll(
      '.action-bar.container .action-bar-wrapper .col a'
    );

    if (buttons) {
      Array.prototype.forEach.call(buttons, function(button) {
        if (value) {
          button.className = button.className.replace('focusable', 'fetching');
        } else {
          button.className = button.className.replace('fetching', 'focusable');
        }
      });
    }

  }

  shouldComponentUpdate(newProps, newState) {
    if (newProps.code && !newProps.code.includes('contenido')) {
      this.ribbonsRecordings = null;
    }
    if (this.props.ribbonsTypeMenu == 'home') {
      this.state.ribbonsPrev = newProps.ribbonsPrev;
      return (
        JSON.stringify(this.props) !== JSON.stringify(newProps) ||
        JSON.stringify(this.state) !== JSON.stringify(newState)
      );
    }
  }

  handleFocus(data, ribbonId, ribbonType) {
    if (this.props.ribbonsTypeMenu == 'home') {
      //console.log('FOCUS RibbonGridNew:::::', data, ribbonId, ribbonType);
      this.currentRibbonIdFocused = ribbonId;
      this.currentRibbonApi = data && data.api;
      this.currentCardFocused = data;
      this.currentRibbonTypeFocused = ribbonType;
      this.focused = document.activeElement.dataset.snLeft;
      //console.log('handleFocus ribbongridNew cual esta activo:::::', this.currentCardFocused);

      if (typeof this.props.focusHandler === 'function') {
        this.props.focusHandler(data);
        this.activePlan = this.props.focusHandler(data);
      }

      if (
        Utils.getToggleFunctionsFromMetadata().scrolling_ribbon_home &&
        !this.props.code.includes('contenido') &&
        this.props.code !== 'series' &&
        !getIsMundial2026(this.props.code)
      ) {
        let item = document.getElementById(
          document.activeElement.getAttribute('id')
        ).parentNode;

        while (item.getAttribute('class') != 'special-ribbon-carousel') {
          item = item.parentNode;
        }

        let position = item.parentNode.offsetTop;
        const isTopRibbon = item.parentNode.classList.contains('top-ribbon');
        const isBottomRibbon = item.parentNode.classList.contains('bottom-ribbon');
        
        if (isTopRibbon && !isBottomRibbon && position < 100 && this.headerImageUrl) {
          document.querySelector(
            '#slider-grid-movies .scroller-container'
          ).style.marginTop = '0px';
          const ribbonGridWrapper = document.querySelector('.ribbongrid-wrapper');
          const container = document.getElementsByClassName('container')[0];
          if (ribbonGridWrapper) {
            setTimeout(() => {
              ribbonGridWrapper.scrollTo({
                top: 0,
                behavior: 'auto'
              });
            }, 200);
          }
          if (container) {
            setTimeout(() => {
              container.scrollTo(0, 0);
            }, 200);
          }
        } else if (!isBottomRibbon) {
          let maxRibbonMarginTop = parseInt(Utils.getMaxRibbonMarginTop(), 10);
          if (position > maxRibbonMarginTop) {
            Utils.setMaxRibbonMarginTop(position);
          }
          document.querySelector(
            '#slider-grid-movies .scroller-container'
          ).style.marginTop = `-${8}px`;
          item.parentNode.scrollIntoView();
        } else if (
          item.parentNode.classList.contains('top-ribbon') ||
          item.parentNode.classList.contains('middle-ribbon')
        ) {
          document.querySelector(
            '#slider-grid-movies .scroller-container'
          ).style.marginTop = '0px';
        }
      }
    }

  }

  componentDidUpdate() {
        const homeCdnConfig = Utils.getRegionaliazedMetadata('home_cdn_config');

        const { history } = this.props;
        const urlFlowType = history && history.location ? history.location.pathname : "";

    this.hasRecordings = this.props.code.includes('contenido');
    const isChannel = this.props.code === 'cfutbol';
    
    const region = DeviceStorage.getItem('region');
    this.headerImageUrl = getNodeHeaderImage(this.props.code, region);

    if (this.props.ribbonsTypeMenu == 'home') {
      let moveToSelector = this.moveToSelector;
      this.moveToSelector = null;

      const afterUpdate = () => {
        const isMundial2026 = getIsMundial2026(this.props.code)
        if (isMundial2026) return

        const modal = document.getElementsByClassName('modal-overlay');
        if (modal.length === 0) {
          if (this.hasRecordings) {
            if (moveToSelector) {
              const ref = window.SpatialNavigation.focus(`.${moveToSelector}`);
              moveToSelector = null;
            } else {
              window.SpatialNavigation.focus('.ribbon-classic .focusable');
            }
            this.resetParent();
          } else if (isChannel) {
            if (moveToSelector) {
              const ref = window.SpatialNavigation.focus(`.${moveToSelector}`);
              moveToSelector = null;
            } else {
              window.SpatialNavigation.focus('.ribbon-classic .focusable');
            }
            this.resetParent();
          }  else {
            if (document.getElementsByClassName('ribbon-highlight').length === 0) {
              window.SpatialNavigation.focus(
                '.elementopredeterminado.focusable'
              );
            } else {
              if (moveToSelector) {
                const ref = window.SpatialNavigation.focus(`.${moveToSelector}`);
                moveToSelector = null;
              } else {
                // Sólo ejecutar si se tiene en false la configuración de: "home_cdn_config.enable".
                // Esto evita que el foco se mueva del Centro de Notificaciones una vez que el Overlay se está mostrando (estado Spotlight).
                if (!homeCdnConfig.enable || (homeCdnConfig.enable && urlFlowType !== '/node/homeuser')) {
                  window.SpatialNavigation.focus('.scroller-container .focusable');
                }
              }
            }
          }
        }
      };
      afterUpdate.bind(this);

      setTimeout(afterUpdate, 300);
    }
  }

  resetParent = () => {
    const scrollerContainer = document.querySelector('#slider-grid-movies .scroller-container');
    if (scrollerContainer && scrollerContainer.style && scrollerContainer.style.marginTop) {
      scrollerContainer.style.marginTop = '0px';
    }
  };

  getRibbonType(type) {
    let ribbonType = 'landscape';

    switch (type) {
      case 'Highlight':
        ribbonType = 'highlight';
        break;
      case 'square':
        ribbonType = 'square';
        break;
      case 'circle':
        ribbonType = 'circle';
        break;
      case 'category':
        ribbonType = 'category';
        break;
      default:
        ribbonType = 'landscape';
        break;
    }

    return ribbonType;
  }

  showRecordingCapacity() {
    return (
      this.ribbonsRecordings !== null && (
        <RecordingProgressBar ribbonRecordings={this.ribbonsRecordings} />
      )
    );
  }

  onFocusCardHandler(data, ribbonType) {
    if (this.props.ribbonsTypeMenu == 'music' && data && data.musicData) {
      // const cardId = `card-${data.music_class}-${data.musicData.id}`;
      const {
        id = false,
        musicData: { id: musicaDataId = 'default value' },
      } = data || {};
      const cardId = `card-${data.music_class}-${id || musicaDataId}`;
      const itemFocused = document.getElementById(cardId);

      let itemSelected = itemFocused;
      if (itemSelected) {
        do {
          itemSelected = itemSelected.parentNode;
        } while (
          itemSelected.classList != undefined &&
          !itemSelected.classList.contains('ribbon-music')
          );

        const topPosition = itemSelected.offsetTop;
        const position = topPosition > 0 ? `-${topPosition}px` : '0px';
        const scrollerContainer = document.querySelector(
          '#slider-grid-movies .scroller-container'
        );
        if (scrollerContainer != null)
          scrollerContainer.style.marginTop = position != undefined ? position : '0px';
      }
      this.props.onFocusHandler(data);
    }
  }

  isString = (ribb) => typeof ribb === 'string';
  idStartsWithNumber = (stringId) => {
    if (this.isString(stringId)) {
      const id = stringId[0];
      return id >= 48 && id <= 57;
    } else return;
  };

  parserId = (id) => `a_${id}`;

  hasTsNPVR = () => {
    const userHasTs = ChannelSingleton.getMaxNpvrStorage();
    if (userHasTs > 0) return true;

    return false;
  };

  filterRecordings = (userRibbons) => {
    let idxRibbonRecording = [];

    if (!Array.isArray(userRibbons)) return { ribbons: userRibbons, idxRibbonRecording: [] };

    if (!this.hasTsNPVR()) {
      const nUserribbons = userRibbons.filter((ribbon, idx) => {
        if (ribbon.type === RECORDINGS) {
          idxRibbonRecording.push(idx);
        }

        return ribbon.type !== RECORDINGS;
      });

      return { ribbons: nUserribbons, idxRibbonRecording };
    }

    return { ribbons: userRibbons, idxRibbonRecording };
  };

  filterRibbons = (ribbons, BlockedRibbonsIds) => {
    if (!Array.isArray(ribbons)) return ribbons;
    if (!Array.isArray(BlockedRibbonsIds)) return ribbons;
    if (BlockedRibbonsIds.length < 1) return ribbons;

    const filtered = [];

    ribbons.forEach((ribbon, idx) => {
      if (!BlockedRibbonsIds.includes(idx)) filtered.push(ribbon);
    });

    return filtered;
  };

  getLinks = () => {
    return Utils.getApaMetadataKey(
      'links_nav_configuration',
      Utils.mock_links_nav_configuration()
    );
  };

  setValueOfferGroupid = (items) => {
    const itemsPS = [];
    items.forEach(function(obj) {
      const param = obj.href.split("&");
      const index = param.find(element => element.startsWith('offer_id='));
      const offerId = index.split('=')[1];
      if (offerId) {
        obj['id'] = offerId;
        obj['offerid'] =  offerId;
        obj['group_id'] =  offerId;
        obj['purchasable'] = "false"
        obj['family'] = "";
        obj['bonus'] = "";
        obj['producttype'] = "";
        obj['periodicity'] = "";
        obj['frequency'] = 0;
      }
      itemsPS.push(obj);
    });
    return itemsPS;
  }

  handleScroll() {
    const altura = document.querySelector('.ribbongrid-wrapper');
    if(altura && altura.offsetHeight === 814){
      document.querySelector('.ribbongrid-wrapper').style.height = '614px';
    }
    removeDynamicFocus();
  }

  render() {
    if (this.props.ribbonsTypeMenu == 'home') {
      const filteredUserRibbons = this.filterRecordings(this.props.ribbonsUser);
      const ribbonsUser = filteredUserRibbons.ribbons;
      const filteredRibbons = this.filterRibbons(
        this.props.ribbonsPrev,
        filteredUserRibbons.idxRibbonRecording
      );
      const ribbonsPrev = filteredRibbons != undefined ? filteredRibbons : undefined;
      const ribbonsRest = this.state.ribbonsRest;

      const ribbonsCategories = this.props.ribbonsCategories;
      const ribbonsInit = [...ribbonsPrev, ...ribbonsRest];

      if (ribbonsUser) {
        ribbonsUser.map((obj) => {
          const ribbonObj = obj;
          const ribbon = ribbonsInit.find((r) => r.id == ribbonObj.id);
          if(ribbon !== undefined){
            const index = ribbonsInit.indexOf(ribbon);
            if (ribbonObj.type === RECORDING && this.props.code.includes(CONTENIDO)) {
              this.ribbonsRecordings = ribbonObj;
            }
            ribbonsInit[index] = Object.assign({}, ribbon, ribbonObj);

            if(ribbon.byUser === FALSE){
              ribbonsInit[index].items = ribbon.items;
            }else{
              if(obj && obj.type === PLANSELECTOR){
                ribbonObj.items = this.setValueOfferGroupid(ribbonObj.items);
              }
              ribbonsInit[index].items = ribbonObj.items;
            }
          }
        });
      }

      if (ribbonsCategories) {
        const [firstRibbon, secondRibbon, thirdRibbon] = ribbonsInit || [];
        const { type = '', id = false } = firstRibbon || {};
        const { id: secondRibbonId = false, items = [] } = secondRibbon || {};
        const addSecondRibbonId = items.length === 0 && AdsUtils.isAdsEnable();
        let index = 0;
        const deleteCount = 0;
        if (type === 'highlight') {
          index = 1;
          ribbonsCategories.items.map((item) => {
            if (id) {
              item.dataSnUp = `#${id} .focusable`;
              const ribbonsShowDeleteButton = Utils.getRegionaliazedMetadata('ribbons_show_delete_button',
                '{default: {favorite: {enable: false}, lastSeen: {enable: false}}}');

              const favoriteShowDeleteButton = (ribbonsShowDeleteButton.favorite &&
                ribbonsShowDeleteButton.favorite.enable &&
                ribbonsShowDeleteButton.favorite.type) || [];

              const lastSeenShowDeleteButton = (ribbonsShowDeleteButton.lastseen &&
                ribbonsShowDeleteButton.lastseen.enable &&
                ribbonsShowDeleteButton.lastseen.type) || [];

              const showDeleteButtonArrayWithOutAds = [...favoriteShowDeleteButton, ...lastSeenShowDeleteButton];
              const showDeleteButtonArrayWithAds = [...favoriteShowDeleteButton,
                ...lastSeenShowDeleteButton,
                secondRibbonId];

              const showDeleteButtonArray = addSecondRibbonId ?
                showDeleteButtonArrayWithAds :
                showDeleteButtonArrayWithOutAds;

              const secondRibbonRef = document.getElementById(secondRibbonId)

              if ((showDeleteButtonArray.includes(secondRibbonId) && items.length === 0) || (!secondRibbonRef && items.length === 0) ) {
                item.dataSnDown = `#${thirdRibbon.id} .focusable`;
              } else {
                item.dataSnDown = `#${secondRibbonId} .focusable`;
              }
            }
            return item;
          });
        }

        ribbonsInit.splice(index, deleteCount, ribbonsCategories);
      }

      console.log('ribbonsInit:::::', ribbonsInit);
      // Obtiene los ribbons con elementos
      const ribbonsWithItems = ribbonsInit.filter((ribbon) => {
        return Array.isArray(ribbon.items) && ribbon.items.length >= 1;
      });
      console.log('ribbonsWithItems:::::', ribbonsWithItems);
      const {
        [ribbonsWithItems.length - 3]: lastButTwoWithItems,
        [ribbonsWithItems.length - 2]: lastButOneWithItems,
        [ribbonsWithItems.length - 1]: lastWithItems,
      } = ribbonsWithItems;

      console.log('lastButTwoWithItems:::::', lastButTwoWithItems, lastButOneWithItems, lastWithItems);
      // Valida el tipo de nodo para mostrar los ribbons con o sin elementos
      const links = this.getLinks();
      const targetNode = links.miscontenidos;
      let ribbons = [];

      console.log('linkssss:::::', links);
      console.log('window.location.pathname:::::', window.location.pathname);
      console.log('targetNode:::::', targetNode);

      if (window.location.pathname == `/node/${targetNode}` || window.location.pathname.includes('miscontenidos') ) {
        ribbons = ribbonsInit;
      } else {
        ribbons = ribbonsWithItems;
        console.log('ribbons a render:::::', ribbons, ribbons.length);
      }

      console.log('ribbons a render:::::', ribbons, ribbons.length);
      const node = new ActivesSingleton().getTvNode();
      const getClassRibbon = (index) => {
        console.log('ribbons.length:::::', index, ribbons.length, ribbons);
        if (ribbons.length <= 2) {
          console.log('ribbons.length:::::', ribbons.length);
          return 'middle-ribbon bottom-ribbon';
        } else {
          return index < ribbons.length - 2 ? 'top-ribbon' : 'bottom-ribbon';
        }
      };
      let ribbonsWithoutItems = 0;
      const idexCarrusel = this.hasRecordings ? 1 : 3;
      const getLiveNextFootballGame = (ribbon) =>{
        return ribbon.items.filter(ribbon => (ribbon.status.scheduleStatus !== undefined && ribbon.status.scheduleStatus !== COMPLETED))
      }

      const region = DeviceStorage.getItem('region');
      const headerImageUrl = getNodeHeaderImage(this.props.code, region);
      this.headerImageUrl = headerImageUrl;
      
      const isMundial2026 = getIsMundial2026(this.props.code)

      return (
        <div className="ribbongrid-wrapper" onPointerMove={this.handleScroll} onWheel={this.handleScroll}>
          {
            headerImageUrl && !isMundial2026 && <div style={{ width: '100%' }} className={'HeadBrandContainer'}>
              <img src={headerImageUrl} alt="" style={{ width: '100%' }}/>
            </div>
          }
          <div
            className="ribbongrid-container"
            id={
              Utils.getToggleFunctionsFromMetadata().scrolling_ribbon_home
                ? 'slider-grid-movies'
                : ''
            }
          >
            <Scrollable
              className={
                this.ribbonsRecordings
                  ? 'scrollabe-container-with-bar'
                  : this.props.code.includes('contenido')
                    ? 'scrollabe-container-without-bar-mis-contenidos'
                    : this.props.code === 'series'
                      ? 'scrollabe-container-modal-series-content' //* Caso para ModalRecordSeriesContent
                      : this.props.code === 'cfutbol'
                        ? 'scrollabe-container-without-bar-channels' //* Caso para Canales en vivo 1 elemento
                        : 'scrollabe-container-without-bar'
              }
            >
              {ribbons.map((ribbon, index) => {
                console.log('ribbon:::::', ribbon);
                //Mundial
                if(ribbon.type === MUNDIALSOCCERMATCHER){
                  ribbon.items = getLiveNextFootballGame(ribbon);
                }

                const { id } = ribbon;
                const api = ribbon.url;

                if (Array.isArray(ribbon.items) && ribbon.items.length < 1) {
                  ribbonsWithoutItems++;
                }

                if (id == 'guia-tv') {
                  if (ribbon && Array.isArray(ribbon.items)) {
                    let props_asset = this.props.asset;
                    ribbon.items.map((it, i) => {
                      const url = encodeURIComponent(`/player/${it.id}/true`);
                      const it_key = it.key;
                      it.cover = props_asset.get(it_key);
                      it.image_still = props_asset.get(it_key);
                      it.src = `/node/${node}?url=${url}`;
                      it.filterTV = i + '';
                    });
                  }
                }

                if (this.idStartsWithNumber(id)) {
                  ribbon.id = this.parserId(id);
                }

                if (ribbon && ribbon.type && ribbon.type == MUSIC_RIBBON_TYPE) {
                  if (
                    this.props &&
                    this.props.user &&
                    this.props.user.isAnonymous
                  ) {
                    if (ribbon.items) {
                      ribbon.items = [];
                    }
                  } else {
                    if (ribbon.items) {
                      const convertItem = Utils.mapRibbonToMusic(
                        ribbon.items
                      );
                      const musicRb = new RibbonsUtil();
                      ribbon.items = musicRb.transformMusicRibbonsElements(
                        convertItem,
                        'playlist',
                        1
                      );
                      if (
                        ribbon &&
                        ribbon.items &&
                        Array.isArray(ribbon.items)
                      ) {
                        ribbon.items.forEach((it) => {
                          if (it && typeof it === 'object') {
                            it.playListFromHome = true;
                          }
                        });
                      }
                    }
                  }
                }

                if (Array.isArray(ribbon.items) && ribbon.items.length === 0) {
                  ribbon.type = VOID;
                }

                let bottomRibbonClassName = getClassRibbon(index);
                const landscape =
                  lastButTwoWithItems &&
                  lastButOneWithItems &&
                  lastWithItems &&
                  lastWithItems.type === 'landscape' &&
                  lastButOneWithItems.type === 'landscape' &&
                  lastButTwoWithItems.type === 'landscape';

                if (index === ribbons.length - 1) {
                  console.log('index primer if:::::', index, ribbons.length - 1, ribbons.length - 2);
                  bottomRibbonClassName += landscape
                    ? ' last-ribbon-landscape'
                    : ' last-ribbon';
                } else if (index === ribbons.length - 2) {
                  bottomRibbonClassName += landscape
                    ? ' last-but-one-ribbon-landscape'
                    : ' last-but-one-ribbon';
                } else if (index === ribbons.length - 3) {
                  bottomRibbonClassName += landscape
                    ? ' last-but-two-ribbon-landscape'
                    : ' last-but-two-ribbon';
                }
                return (
                  <SpecialRibbon
                    index={index}
                    bottomRibbon={bottomRibbonClassName}
                    user={this.props.user}
                    key={Math.random() * 10}
                    {...ribbon}
                    focusHandler={this.handleFocus}
                    setMetricsEvent={this.props.setMetricsEvent}
                    forceUpdateGrid={this.props.forceUpdateGrid}
                    hasRecordings={this.hasRecordings}
                    api={api}
                    handleDeleteFromRibbonRecordings={
                      this.handleDeleteFromRibbonRecordings
                    }
                    code={this.props.code}
                    history={this.props.history}
                    idsRibbonsUpAndDown = {getIdsRibbonsUpAndDown(ribbons)}
                  />
                );
              })}
            </Scrollable>
          </div>
          {this.hasRecordings && this.showRecordingCapacity()}
        </div>
      );
    } else {
      const ribbonsCategories = this.props.ribbonsCategories;
      const ribbons = this.props.ribbons;

      if (ribbonsCategories) {
        const [firstRibbon, secondRibbon, ...rest] = ribbons || [];
        const { type = '', id = false } = firstRibbon || {};
        const { id: secondRibbonId = false, type: type2 = '' } = secondRibbon || {};
        let index = 0;
        const deleteCount = 0;

        if (type === 'carousel') {
          index = 1;
          ribbonsCategories.items.map((item) => {
            if (id) {
              item.dataSnUp = `#${id} .focusable`;
              item.dataSnDown = `#${secondRibbonId} .focusable`;
            }
            return item;
          });
        }

        ribbons.splice(index, deleteCount, ribbonsCategories);
      }

      return (
        <div
          className="ribbongrid-wrapper"
          id={
            Utils.getToggleFunctionsFromMetadata().scrolling_ribbon_home
              ? 'slider-grid-movies'
              : ''
          }
          onPointerMove={this.handleScroll}
          onWheel={this.handleScroll}
        >
          <div className="ribbongrid-container" id="slider-grid-movies">
            <Scrollable height={'410px'}>
              {ribbons.map((ribbon, index) => {
                const {
                  ribbonItems,
                  ribbonTitle,
                  ribbonType,
                  ribbonId
                } = getParamsRibbons(ribbon, this.getRibbonType, this.props.isMusic);

                return (
                  <div key={index} className="ribbongrid-row ribbon-music">
                    <Ribbon
                      id={ribbonId}
                      index={index}
                      type={ribbonType}
                      title={ribbonTitle}
                      items={ribbonItems}
                      focusable={true}
                      focusHandler={this.onFocusCardHandler}
                      visibleNumber={this.props.visibleNumber}
                      setMetricsEvent={this.props.setMetricsEvent}
                      carruselTitle={ribbonTitle}
                      code={this.props.code}
                      idsRibbonsUpAndDown = {getIdsRibbonsUpAndDown(ribbons, false, this.props.isMusic)}
                      isMusic={this.props.isMusic}
                    />
                  </div>
                );
              })}
            </Scrollable>
          </div>
        </div>
      );
    }
  }
}

RibbonGrid.propTypes = {
  ribbonsPrev: PropTypes.array,
  user: PropTypes.shape({
    isLoggedIn: PropTypes.bool,
    isSusc: PropTypes.bool,
  }),
  focusHandler: PropTypes.func,
};

RibbonGrid.defaultProps = {
  user: {},
  ribbonsPrev: [],
  focusHandler: null,
};

export default RibbonGrid;



// WEBPACK FOOTER //
// ./src/components/RibbonGridNew/index.jsx